import React from 'react';
import { ArrowRight, Sparkles, Gamepad2 } from 'lucide-react';

const CTA = ({ t }) => {
  return (
    <section id="section-5" className="py-20 bg-gradient-to-br from-teal-600 to-teal-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center text-white">
          <div className="mb-8">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-white/20 rounded-full mb-6">
              <Sparkles className="w-10 h-10 text-white" />
            </div>

            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold mb-6">{t.title}</h2>

            <p className="text-lg sm:text-xl text-teal-100 max-w-3xl mx-auto mb-8">{t.subtitle}</p>
          </div>

          <div className="flex justify-center items-center mb-12">
            <a
              href="/s"
              className="bg-white text-primary px-8 py-4 rounded-xl font-semibold text-lg hover:bg-teal-50 transition-colors duration-200 flex items-center space-x-2 shadow-lg"
            >
              <Gamepad2 className="w-6 h-6" />
              <span>{t.cta}</span>
              <ArrowRight className="w-5 h-5" />
            </a>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-teal-100">
            {t.features.map((feature, index) => (
              <div key={index} className="flex items-center space-x-2">
                <div className="w-2 h-2 bg-amber-300 rounded-full" />
                <span className="text-sm font-medium">{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
